import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  Signal,
  signal,
  WritableSignal
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ClickableRowComponent } from '../../../../../shared/components/clickable-row/clickable-row.component';
import { CheckoutDetailsCartItemComponent } from './checkout-details-cart-item/checkout-details-cart-item.component';
import { slideInOut } from '../../../../../shared/transitions/slide-in-out.transition';
import { select, Store } from '@ngxs/store';
import { CartItemsAction } from '../../../../../shared/state/cart/cart.actions';
import {
  WooCommerceCartItem,
  WooCommerceCartTotals
} from '../../../../../core/interfaces/woo-commerce/api/cart/cart.interface';
import { CartState } from '../../../../../shared/state/cart/cart.state';
import { ProductImagePipe } from '../../../../../shared/pipes/product-image.pipe';

@UntilDestroy()
@Component({
  selector: 'app-checkout-details-cart',
  animations: [slideInOut],
  imports: [
    FormsModule,
    ClickableRowComponent,
    CheckoutDetailsCartItemComponent,
    ProductImagePipe
  ],
  templateUrl: './checkout-details-cart.component.html',
  styleUrl: './checkout-details-cart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutDetailsCartComponent {
  isLocked: InputSignal<boolean> = input<boolean>(false);
  cartItems: Signal<WooCommerceCartItem[]> = select(CartState.items);
  cartTotals: Signal<WooCommerceCartTotals> = select(CartState.totals);
  isDeleteLoading: Signal<boolean> = select(CartState.isLoading('deleteItem'));
  isUpdateLoading: Signal<boolean> = select(CartState.isLoading('updateItem'));
  isAddItemLoading: Signal<boolean> = select(CartState.isLoading('addItem'));
  isSyncLoading: Signal<boolean> = select(CartState.isLoading('sync'));

  isCartExpanded: WritableSignal<boolean> = signal<boolean>(false);

  constructor(private store: Store) {}

  updateProductQuantity(key: string, quantity: number) {
    if (this.isLocked()) {
      return;
    }

    this.store.dispatch(
      new CartItemsAction.Update({ key, quantity })
    );
  }

  removeProduct(productKey: string) {
    if (this.isLocked()) {
      return;
    }

    this.store.dispatch(new CartItemsAction.Remove(productKey));
  }
}
